import { SearchableCollection } from 'state/search/reducer'
import { Collection } from 'types/nft'
import { shortenAddress } from 'utils'

const MAX_COLLECTION_RESULTS = 10
const ADDRESS_QUERY_PATTERN = /^(0x[0-9a-f]{40})(?:\/(\d+))?$/i

export interface ParsedSearchQuery {
  text: string
  address?: string
  tokenId?: string
}

export const parseSearchQuery = (query: string): ParsedSearchQuery => {
  const text = query.trim()
  const match = ADDRESS_QUERY_PATTERN.exec(text)
  if (!match) {
    return { text }
  }
  return { address: match[1].toLowerCase(), text, tokenId: match[2] }
}

export const toSearchableCollection = (
  collection: Collection
): SearchableCollection => ({
  address: collection.address,
  chain: collection.chain,
  name: collection.name || shortenAddress(collection.address),
  numItems: collection.numItems,
  pfpUrl: collection.pfpUrl,
  slugName: collection.slugName,
  verified: collection.verified
})

const matchesQuery = (collection: Collection, query: string): boolean =>
  collection.address.startsWith(query) ||
  collection.name.toLowerCase().includes(query) ||
  (collection.slugName?.toLowerCase().includes(query) ?? false)

const startsWithQuery = (collection: Collection, query: string): boolean =>
  collection.name.toLowerCase().startsWith(query) ||
  (collection.slugName?.toLowerCase().startsWith(query) ?? false)

export const searchCollections = (
  registry: Collection[],
  text: string
): SearchableCollection[] => {
  const query = text.toLowerCase()
  return registry
    .filter((collection) => matchesQuery(collection, query))
    .sort((a, b) => {
      const rankA = startsWithQuery(a, query) ? 0 : 1
      const rankB = startsWithQuery(b, query) ? 0 : 1
      return rankA - rankB || a.name.localeCompare(b.name)
    })
    .slice(0, MAX_COLLECTION_RESULTS)
    .map(toSearchableCollection)
}
